import { render, staticRenderFns } from "./GeneralForm.vue?vue&type=template&id=40d6f0ca&scoped=true"
import script from "./GeneralForm.vue?vue&type=script&lang=js"
export * from "./GeneralForm.vue?vue&type=script&lang=js"
import style0 from "./GeneralForm.vue?vue&type=style&index=0&id=40d6f0ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d6f0ca",
  null
  
)

export default component.exports